/**
 * Shared 9-step ColorBrewer RdYlGn ramp (reversed) used by the heatmap
 * choropleth + the legend gradient on the map page.
 *
 * Lives outside HeatmapMap.tsx because that file imports Leaflet at
 * module top, which touches `window` and breaks any server-rendered
 * caller. The map page's legend needs the colours statically (it
 * builds a `linear-gradient` from them); pulling the constant here
 * lets the legend import without triggering the Leaflet evaluation.
 */
export const HEATMAP_COLORS = [
  "#1a9850",
  "#66bd63",
  "#a6d96a",
  "#d9ef8b",
  "#fee08b",
  "#fdae61",
  "#f46d43",
  "#d73027",
  "#a50026",
] as const;
